import SimpleBarChart from '@components/SimpleBarChart';
import { formatOneDigitNumber, plainAverage } from '@utils/formatters';
import _ from 'lodash';

import ratingToIndex from '../features/opcon/ratingToIndex';
import createColumn from './createColumn';

export const scoreSignal = {
    format: (value: number | '-') => {
        if (_.isNumber(value)) {
            return (
                <div className="max-width-100 height-20" >
                    <SimpleBarChart activeIndex={ratingToIndex(value)} tooltip={formatOneDigitNumber(value)} />
                </div>
            );
        }
        return value;
    },
    average: plainAverage,
    unit: 'score',
};

export const operationCondition = createColumn({
    key: 'operationCondition',
    dataField: 'operationCondition',
    labelId: 'operationCondition',
    formatter: scoreSignal.format,
    dataSort: true,
});
